export default {
    API_BASE_URL: '/api/v1/',
    // API_BASE_URL: 'http://localweb/shmu-services/public/v1/',
    // API_BASE_URL: 'http://10.100.100.113/shmu-services/public/v1/',
    MAP_TILE_URL: '/',
    SHMU_CORE_URL: '/',
    ENABLE_SNOW_INFO: true,
    ENABLE_UV_INDEX: true,
    VERSION: '20241119-01',
    GOOGLE_API_KEY: 'AIzaSyBwuWkj-ZrYbd6ek8QX6FqfaXe-eBrS4cc',
    GA_TAG_ID: 'UA-307719-1',
    GTM_ID: 'GTM-PJWC9CR',
}
